import { Injectable } from '@angular/core'
import { NotificationsService } from 'angular2-notifications'

@Injectable()
export class NotificationService {
  private options

  constructor(private notificationsService: NotificationsService) {

    this.options = {
      position: ['bottom', 'right'],
      timeOut: 5000,
      lastOnBottom: true,
      pauseOnHover: false,
      showProgressBar: true,
      clickToClose: true,
      maxStack: 2,
      preventDuplicates: true,
    }
  }

  public getNotificationsOptions() {
    return this.options
  }

  public showInfoNotification(title: string, content: string): void {
    this.notificationsService.info(
      title,
      content,
      this.options
    )
  }

  public showSuccessNotification(title: string, content: string): void {
    this.notificationsService.success(
      title,
      content,
      this.options
    )
  }

  public showErrorNotification(title: string, content: string): void {
    this.notificationsService.error(
      title,
      content,
      this.options
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/notifications/notification.service.ts